export const firebaseConfig = {
  apiKey: 'AIzaSyA7x2fXXsiqpHFjggMSeyjevuUxPuCZLLY',
  authDomain: 'filmoteka-6f1f2.firebaseapp.com',
  projectId: 'filmoteka-6f1f2',
  storageBucket: 'filmoteka-6f1f2.appspot.com',
  messagingSenderId: '872031446317',
  appId: '1:872031446317:web:8897579d15e13506acdfa4',
  measurementId: 'G-MRXLMWVJH8',
};
